import { Stack, Typography } from '@mui/material';
import {
  DvsStatus as DvsStatusComponent,
  IdentityDocumentType,
  TDocumentVerificationStatusActions,
  useConfirm,
} from '@verifime/components';
import tokens from '@verifime/design-tokens';
import { useDvsData } from './hooks/useDvsData';

export function DvsStatus({
  customerId,
  documentType,
}: Readonly<{
  customerId: string;
  documentType: keyof typeof IdentityDocumentType;
}>) {
  const { status, dvsErrorDetails, resetStatus, resubmit } = useDvsData(customerId, documentType);
  const confirm = useConfirm();

  const handleResetStatus = (status: keyof TDocumentVerificationStatusActions) => {
    confirm({
      content: (
        <Typography>
          The action you are about to carry out will manually override the DVS status. Do you wish
          to proceed?
        </Typography>
      ),
      confirmationText: 'Confirm',
    }).then(() => {
      resetStatus(status);
    });
  };

  const handleResubmit = () => {
    confirm({
      content: (
        <Stack gap={tokens.spacingBase}>
          <Typography>
            The action you are about to carry out will resubmit the identity document for DVS
            validation? Please confirm you wish to proceed?
          </Typography>
          <Typography variant="h6">NB: This action incurs external costs from DVS.</Typography>
        </Stack>
      ),
      confirmationText: 'Confirm',
    }).then(() => {
      resubmit();
    });
  };

  // Only pass onResubmit if document type allows resubmission
  const canResubmit = documentType !== IdentityDocumentType.OtherIdentityDocument;

  return (
    <DvsStatusComponent
      status={status}
      errorDetails={dvsErrorDetails}
      onResetStatus={handleResetStatus}
      onResubmit={canResubmit ? handleResubmit : undefined}
    />
  );
}
